import i18n from "i18next";
import translations from "./translations.json";
import {initReactI18next} from "react-i18next";
import HttpBackend from 'i18next-http-backend';
import {CatalogType} from "../client/catalog/CatalogType";

const {serverApiUrl} = window._envConfig;

export type TranslationFunction = (key: string) => string;

i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
        resources: translations,
        lng: "cs",
        fallbackLng: "cs",
        ns: Object.values(CatalogType),

        backend: {
            loadPath: `${serverApiUrl}/catalogs/{{ns}}/translations/{{lng}}`,
        },

        partialBundledLanguages: true,

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
